import moment from "moment";

export const localizeServerDateInUserTimezone = (dateInMoscowTimezone, format) => {
  const dateInUtc = moment(dateInMoscowTimezone)
  return dateInUtc.local().format(format);
};